import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { Gender, IProfileState } from ".";

export interface ISetGenderResponse {
    gender: Gender;
};

export const setGender = createAsyncThunk<ISetGenderResponse, number>(
    'setGender',
    async (gender: Gender) => await api.profiles.setGender(gender)
);

export const setGenderHandler = (builder: ActionReducerMapBuilder<IProfileState>) => {    
    builder
        .addCase(setGender.pending, (state: IProfileState) => {
            state.loading = true;
            state.error = "";
        })
        .addCase(setGender.fulfilled, (state: IProfileState, action: PayloadAction<ISetGenderResponse>) => {
            state.loading = false;
            state.gender = action.payload?.gender;
        })
        .addCase(setGender.rejected, (state: IProfileState) => {
            state.loading = false;
            state.error = 'Unable to set gender';
        });
};

export default setGenderHandler;